module.exports = __webpack_public_path__ + "img/6left-n-e21e8e21.png";